// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3wagM","filesListContainer":"PosDisputesFiles_filesListContainer__1xbv8","filesButton":"PosDisputesFiles_filesButton__2VmtQ"};